<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename"><span class="c8-titlename__text">两面横版走势</span></div>
      </div>
    </div>

    <LiangMianHengBanZouShihContent
      :lottery-code="lotteryCode"
      :lottery-type="lotteryType"
    />
  </div>
</template>

<script>
import LiangMianHengBanZouShihContent from '@/components/web/pages/trend/LiangMianHengBanZouShih/content'
// pk10

export default {
  name: 'WebLiangMianHengBanZouShih', // 兩面橫版走勢
  components: {
    LiangMianHengBanZouShihContent
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code
    }
  }
}
</script>
